
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Dropdown } from "react-bootstrap";
import Select from "react-select";
import {Threebox, THREE} from "threebox-plugin";
import React,{useRef, useState, useEffect} from "react";

class turbine3d {
	
	turbineOptions = [
		{
			value:'1', 
			label:'Enercon E70',
			model: 'Enercon_E70_2.glb',
			type: 'gltf'
		},
		{
			value:'2', 
			label:'Vestas V136',
			model: 'Vestas_V136.glb',
			type: 'gltf'
		},
	];
	selectedTurbine = this.turbineOptions[0];
	defaultTerrainExageration = 1;
	
	constructor(map, scenario){
		this.map = map;
		this.scenario = scenario;
		this.es = this._escape.bind(this);
		this.at = this._escape.bind(this);
		this.clickedButton = null;
		this.models = [];
		this.active = false;
		window.tb = this.tb = new Threebox(
			this.map,
			this.map.getCanvas().getContext('webgl'),
			{
				defaultLights: true,
				terrain:false,
				sky: true,
				//enableSelectingObjects: true,
				//enableDraggingObjects: true
			}
		);
			
	
		this.panel = React.createRef();
		this.range1 = React.createRef();
		this.rangeValue = React.createRef();
		
	}

	init(){
		//clear other button event handlers
		//this.clickedButton.classList.add('active');
		this.exitOthers();
		this.map.on('keyup', this.es);
		this.map.on('addTurbine', (e)=>{this._refreshModels(e)});
		this.map.on('removeTurbine', (e)=>{this._refreshModels(e)});
		
		this.map.disableEvents = 1;
		var self = this;
	}
	_escape(e){
		if(e.keyCode === 27 /*escape*/) {
			this.exit();
		}
	}
	
	_refreshModels(e){
		this.clearModels();
		this.showModels();
	}
	setScenario(scenario){
		this.scenario = scenario;
		//this.map.controlBar.enable('view3d');
	}
	exit(){
		this.clearEventHandlers();
		this.map.disableEvents = 0;
		
		this.clearModels();
		//close 3d dialog
		
		this.map.flyTo({
		  center: this.map.initialCenter,
		  pitch: 0,
		  bearing: 0,
		  duration: 1000,
		  zoom: 12
		});
		this.map.dragRotate.disable();
		
//		if(this.clickedButton){
//			this.clickedButton.classList.remove('active');
//			this.clickedButton = null;
//		}
		this.active = false;
		this.hidePanel();
	}
	clearEventHandlers(){
		this.map.off('keyup', this.es);
	}
	view3d(e){
		if(this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.active = true;
		this.init();
		
		//show 3d view, open dialog for control
		this.showModels();
		this.showPanel();
		this.map.dragRotate.enable();
		this.map.flyTo({
		  center: this.map.initialCenter,
		  pitch: 60,
		  bearing: 0,
		  duration: 1000,
		  zoom: 16
		});
	}
	toggle(e){
		if(this.active){ //if clicking the same button again exit function
			this.exit();
			return true;
		}
		return false;
	}
	exitOthers(){
		const event = new KeyboardEvent("keyup",{
			'keyCode': 27
		});
		this.map.getContainer().dispatchEvent(event);
	}
	showPanel(){
		this.panel.current.classList.remove("d-none");
		this.panel.current.classList.add("d-block");
		this.map.getContainer().classList.add("mode-3d");
	}
	hidePanel(){
		this.panel.current.classList.remove("d-block");
		this.panel.current.classList.add("d-none");
		this.map.getContainer().classList.remove("mode-3d");
	}
	toggleVisibility(show){
		
		this.tb.toggleLayer('3d-turbines', show);
	}
	clearModels(){
		
		this.models.forEach((m)=>{
			m.stop();
			this.tb.remove(m);
		});
		if(this.map.getLayer('3d-turbines'))
			this.map.removeLayer('3d-turbines');
		
	}
	getModelOptions(){
		return {
			type: this.selectedTurbine.type, //'gltf'/'mtl'
			obj: '/images/models/'+this.selectedTurbine.model, //model url
			units: 'meters', //units in the default values are always in meters
			scale: 1,
			rotation: { x: 90, y: this.scenario.wind_direction+90, z: 0 }, //default rotation
			anchor: 'auto'
		}
	}
	placeModel(model, turbine){
		
		const elevation = this.map.queryTerrainElevation(turbine.geometry.coordinates);
		var coord = [...turbine.geometry.coordinates, elevation];
		model.originalCoordinates = turbine.geometry.coordinates;
		model.originalAltitude = elevation;
		var s = model.setCoords(coord);
		s.playAnimation({animation:0, duration:100000});
		//shadows must be false, or setcoords fails
		s.castShadow = false;
		this.tb.add(s);
		this.models.push(s);
	}
	
	showModels(){
		let self = this;
		//create the layer
		let modelsLayer = {
			id: '3d-turbines',
			type: 'custom',
			renderingMode: '3d',
			slot:'top',
			onAdd: function (map, gl) {
				
				self.scenario.wtgs.forEach((turbine)=>{
					self.tb.loadObj(self.getModelOptions(), function (model) {
						self.placeModel(model, turbine);
					});					
				});
				

				
			},
			render: function (gl, matrix) {
				//tb.setSunlight(date, origin); //set Sun light for the given datetime and lnglat
				//let dupDate = new Date(date.getTime()); // dup the date to avoid modify the original instance
				//let dateTZ = new Date(dupDate.toLocaleString("en-US", { timeZone: 'Australia/Sydney' }));
				self.tb.update();
			}
		};
		this.map.addLayer(modelsLayer);
		
	}
	changeTurbine(e){
		
		this.selectedTurbine = e;
		this.clearModels();
		this.showModels();
	}
	animate(e){
		this.models.forEach((m)=>{
			if(e)
				m.playAnimation({animation:0, duration:100000});
			else
				m.stop();
		});
	}
	topography(e){
		
		//stop animations otherwhise idle event does not occur
		this.animate(false);
		if(e.target.checked){
			this.range1.current.classList.replace("d-none", "d-block");
			this.tb.terrain = true;
			this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': this.defaultTerrainExageration });
			this.map.once('idle', () => {
				this.clearModels();
				this.showModels();
			});
		}
		else {
			this.range1.current.classList.replace("d-block", "d-none");
			this.map.setTerrain(null);
			this.map.removeSource('mapbox-dem');
			this.showModels();
		}
	}
	setTerrainExageration(value){
		this.tb.altitudeStep = .1
		var multiplier = parseFloat(value);
		this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': multiplier });
		
		this.models.forEach((m)=>{
			m.setCoords([...m.originalCoordinates, this.map.queryTerrainElevation(m.originalCoordinates)]);
		});
		//obj.setcoords does not work well, it moves the object too much verticaly when setting the altitude
		//i noticed that after setting the altitude, if i zoom out, the object would be placed correctly
		//so i just reset the zoom to make the viewport render the view again, and this way the turbines show fine
		this.map.setZoom(this.map.getZoom());
		
		this.rangeValue.current.innerText = multiplier;
	}
	clearModels(){
		
		this.models.forEach((m)=>{
			this.tb.remove(m);
		});
		if(this.map.getLayer('3d-turbines'))
			this.map.removeLayer('3d-turbines');
		
	}	
	
	dialog(){
		
		return (
			<div className="view3d-panel d-none" ref={this.panel} >
				<Row>
					<Col xs="12">
						<b>Turbine Model</b>
					</Col>
					<Col xs="12 mt-2 mb-3">

						<Select defaultValue={this.selectedTurbine} options={this.turbineOptions} onChange={(t)=>{this.changeTurbine(t)}}  isSearchable={false}  />

					</Col>
					<Col xs="12">
						<b>Viewing options</b>
					</Col>
					<Col xs="9 mt-2">
						Shadows
					</Col>
					<Col xs="3 mt-2">
						<Form.Check id="" value="1" onClick={(e)=>{;}} type="switch" defaultChecked={false} />
					</Col>

					<Col xs="9 mt-2">
						Animate
					</Col>
					<Col xs="3 mt-2 mb-3">
						<Form.Check id="" value="1" onClick={(e)=>{this.animate(e.target.checked);}} type="switch" defaultChecked={true} />
					</Col>
					
					<Col xs="9 mt-2">
						Topography
					</Col>
					<Col xs="3 mt-2">
						<Form.Check id="" value="1" onClick={(e)=>{this.topography(e);}} type="switch" defaultChecked={false} />
					</Col>
					<div className=" d-none" ref={this.range1} >
						<Col xs="12 text-center">
						<small>Terrain exageration (x<span ref={this.rangeValue}>{this.defaultTerrainExageration}</span>)</small>
						</Col>
						<Col xs="12 mb-3">
							<Form.Range min="1" max="5" step="0.1" defaultValue={this.defaultTerrainExageration} onChange={(e)=>{this.setTerrainExageration(e.target.value);}} />
						</Col>
					</div>

				</Row>
			</div>	
		);
		
	}
	
	

}
export default turbine3d;